import { Field, ErrorMessage } from 'formik';

const Input = ({
  name,
  label,
  placeholder = '',
  optional = false,
  disabled = false,
  children = null,
  as: Tag = 'input',
  format = null,
  inputClassName = '',
  icon = null
}) => (
  <Field name={name}>
    {({ field, form }) => (
      <div className={`${icon ? 'relative' : ''} form-control`}>
        <label className="label pb-1.5">
          <span className="label-text font-medium">{label}</span>
          {optional && (
            <span className="label-text-alt text-base-content/40 font-normal normal-case text-xs">
              Optional
            </span>
          )}
        </label>

        {icon && (
          <span
            className="absolute pointer-events-none text-base-content/40 flex items-center"
            style={{ left: '0.75rem', top: '2rem', height: '3rem' }}
          >
            {icon}
          </span>
        )}

        <Tag
          {...field}
          onChange={format ? (e) => form.setFieldValue(name, format(e.target.value)) : field.onChange}
          placeholder={placeholder}
          disabled={disabled}
          className={`${Tag} ${Tag}-bordered w-full ${inputClassName}`}
        >
          {children}
        </Tag>

        <ErrorMessage name={field.name} render={(msg) => (
          <label className="label pt-1">
            <span className="label-text-alt text-error">{msg}</span>
          </label>
        )} />
      </div>
    )}
  </Field>
);

export default Input;
